import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { createMetrikaTracker } from './metrika.js';

// One tracker per document also prevents duplicate pageviews in React StrictMode.
const tracker = createMetrikaTracker(window, document);

export default function Metrika() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    tracker.visit(window.location.href, document.title);
  }, [pathname, search]);
  return null;
}
